import type { DesignTokens } from '@vibesites/tokens';
import { defaultTokens } from '@vibesites/tokens';

// Quinn fallbacks for a property with no MultiHub colours. At runtime the property palette
// replaces primary / secondary / text / surface; src/styles/quinn.css derives paper, surface
// band, hairlines and ink from the primary, and reads property_color_3 (which the runtime
// writes to `surface`) as the Quinn accent.
export const tokens: Partial<DesignTokens> = {
  color: {
    ...defaultTokens.color,
    primary: '#1F4F44',
    secondary: '#616C38',
    accent: '#E7BF9D',
    background: '#FBFAF7',
    surface: '#E7BF9D',
    text: '#1F2A28',
    textMuted: '#5C6663',
    textOnPrimary: '#FBFAF7',
    textOnSecondary: '#FBFAF7',
    border: '#D1D1CA',
    error: '#B3412F',
    success: '#3E7A5A',
    warning: '#B98A2E',
  },
  font: {
    ...defaultTokens.font,
    heading: "'Fraunces', serif",
    body: "'Inter', sans-serif",
  },
  fontSize: {
    xs: '12px',
    sm: '14px',
    base: '16px',
    lg: '18px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '30px',
    '4xl': '36px',
    '5xl': '48px',
    '6xl': '60px',
  },
  fontWeight: { ...defaultTokens.fontWeight },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    '2xl': '48px',
    '3xl': '64px',
    '4xl': '96px',
  },
  radius: {
    none: '0',
    sm: '2px',
    md: '4px',
    lg: '8px',
    xl: '12px',
    full: '9999px',
  },
  shadow: { ...defaultTokens.shadow },
  transition: { ...defaultTokens.transition },
};

export default tokens;
